import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { CidadeModule } from '../cidade';
import { PessoaTipoPipeModule } from './tipo';
import { PaisSharedModule } from '../pais';
import { IdentificadorMatrizFilialModule } from '../common/identificador-matriz-filial';
import { EmpresaSituacaoCadastralModule } from '../common/empresa-situacao-cadastral';
import { NaturezaJuridicaFormControlModule } from '../common/natureza-juridica/components/form-control';
import { PorteEmpresaFormControlModule } from '../common/porte-empresa/components/form-control';
import { FileUploadModule } from 'ng2-file-upload';

import { PessoaFormComponent } from './form';
import { PessoaContatoModule } from './contato';
import { PessoaEnderecoModule } from './endereco';
import { PessoaCrudHttpService } from './services';
import { ClienteBaixaModule } from './cliente/baixa';
import { ClientePreBaixaModule } from './cliente/pre-baixa';
import { ClienteCongelamentoCardInfoModule } from './cliente/congelamento';


@NgModule({
    imports: [
        SharedModule,
        PessoaTipoPipeModule,
        PessoaContatoModule,
        PessoaEnderecoModule,
        PaisSharedModule,
        CidadeModule,
        FileUploadModule,
        ClienteCongelamentoCardInfoModule,
        ClienteBaixaModule,
        ClientePreBaixaModule,
        IdentificadorMatrizFilialModule,
        EmpresaSituacaoCadastralModule,
        NaturezaJuridicaFormControlModule,
        PorteEmpresaFormControlModule
    ],
    declarations: [
        PessoaFormComponent
    ],
    exports: [
        SharedModule,

        PessoaFormComponent,
        // Contato
        PessoaContatoModule,
        // Endereço
        PessoaEnderecoModule
    ],
    providers: [
        PessoaCrudHttpService
    ]
})
export class PessoaSharedModule { }
